import { useEffect, useState } from 'react';
import './ApplicationsContent.css';
import NewApplication from '../../components/NewApplication/NewApplication';
import { getPatentApplications } from '../../utilities/api/patentApplications';
import { getTrademarkApplications } from '../../utilities/api/trademarkApplications';
import PatentApplicationsList from '../../components/PatentApplicationsList/PatentApplicationsList';
import TrademarkApplicationsList from '../../components/TrademarkApplicationsList/TrademarkApplicationsList';
import ApplicationReminders from '../../components/ApplicationReminders/ApplicationReminders';
import SearchBar from '../../components/SearchBar/SearchBar';

export default function ApplicationsContent({ user, toggleNotifications, isMobile, patentApplicationPreferences, trademarkApplicationPreferences }) {
  const [loading, setLoading] = useState(false)
  const [patentApplications, setPatentApplications] = useState([])
  const [trademarkApplications, setTrademarkApplications] = useState([])
  const [patentSortOrder, setPatentSortOrder] = useState('desc')
  const [patentSortHeader, setPatentSortHeader] = useState('clientID')
  const [trademarkSortOrder, setTrademarkSortOrder] = useState('desc')
  const [trademarkSortHeader, setTrademarkSortHeader] = useState('clientID')

  const updatePatentApplications = (updatedData) => {
    updatedData.sort((a, b) => {
      if (patentSortOrder === 'asc') {
          return ((typeof(a[patentSortHeader])==='string' ? a[patentSortHeader].toLowerCase() : a[patentSortHeader]) > (typeof(b[patentSortHeader])==='string' ? b[patentSortHeader].toLowerCase() : b[patentSortHeader])) ? 1 : -1
      } else {
          return ((typeof(a[patentSortHeader])==='string' ? a[patentSortHeader].toLowerCase() : a[patentSortHeader]) < (typeof(b[patentSortHeader])==='string' ? b[patentSortHeader].toLowerCase() : b[patentSortHeader])) ? 1 : -1
      }
    });
    setPatentApplications(updatedData)
  }

  const updateTrademarkApplications = (updatedData) => {
    updatedData.sort((a, b) => {
      if (trademarkSortOrder === 'asc') {
          return ((typeof(a[trademarkSortHeader])==='string' ? a[trademarkSortHeader].toLowerCase() : a[trademarkSortHeader]) > (typeof(b[trademarkSortHeader])==='string' ? b[trademarkSortHeader].toLowerCase() : b[trademarkSortHeader])) ? 1 : -1
      } else {
          return ((typeof(a[trademarkSortHeader])==='string' ? a[trademarkSortHeader].toLowerCase() : a[trademarkSortHeader]) < (typeof(b[trademarkSortHeader])==='string' ? b[trademarkSortHeader].toLowerCase() : b[trademarkSortHeader])) ? 1 : -1
      }
    });
    setTrademarkApplications(updatedData)
  }

  const getAllApplications = async () => {
    setLoading(true)
    try {
      const allPatentApplications = await getPatentApplications(user)
      const allTrademarkApplications = await getTrademarkApplications(user)
      setPatentApplications(allPatentApplications.sort((a, b) => a[patentSortHeader] < b[patentSortHeader] ? 1 : -1))
      setTrademarkApplications(allTrademarkApplications.sort((a, b) => a[trademarkSortHeader] < b[trademarkSortHeader] ? 1 : -1))
    } catch (err) {
      console.log(err)
    }
    setLoading(false)
  }

  // console.log('patentApplications', patentApplications)
  // console.log('trademarkApplications', trademarkApplications)


  useEffect(() => {
    getAllApplications()
    // eslint-disable-next-line
  },[])

  return (
    <div className='ApplicationsContent'>
      <div className='applicationsHeadingContainer'>
        <div className='section1'>
          <div className='title'>
            Applications
          </div>
          <SearchBar user={user} section={'applications'} updatePatents={updatePatentApplications} updateTrademarks={updateTrademarkApplications} />
        </div>
        { ['admin', 'manager'].includes(user.userType) &&
        <div className='section2'>
          <button className='reminders' data-bs-toggle="modal" data-bs-target="#remindersModal">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" fill="currentColor" className="bi bi-calendar-fill" viewBox="0 0 16 16">
              <path d="M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V5h16V4H0V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5"/>
            </svg>
          </button>
          <ApplicationReminders toggleNotifications={toggleNotifications} user={user} />
          <button className='addApplication' data-bs-toggle="modal" data-bs-target="#newApplicationModal">
            <svg width="20" viewBox="0 0 38 38" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect width="38" height="38" rx="10" fill="#FFFFFF" opacity='0.05'/>
                <path d="M19 11V27V11ZM27 19H11H27Z" fill="#2173F0"/>
                <path d="M19 11V27M27 19H11" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
            <span>&nbsp;&nbsp;Add Application</span>
          </button>
          <NewApplication user={user} toggleNotifications={toggleNotifications} updatePatentApplications={updatePatentApplications} updateTrademarkApplications={updateTrademarkApplications} />
        </div>
        }
      </div>
      { loading ?
      <div className='loading'>
        <div className="spinner-border" role="status"></div>
      </div>
      :
      <div className='applicationsMainSection'>
        <div className="nav nav-tabs flex-row navigation" id="v-tab" role='tablist' aria-orientation="horizontal">
          <button className="nav-link active" id='patentApplicationsTab' data-bs-toggle="tab" role="tab" aria-controls="patentApplications" aria-selected="true" data-bs-target="#patentApplicationsList" type="button">
            <span>Patent</span>
            {!isMobile&& 
            <span> Applications</span>
            }
          </button>
          <button className="nav-link" id='trademarkApplicationsTab' data-bs-toggle="tab" role="tab" aria-controls="trademarkApplications" aria-selected="false" data-bs-target="#trademarkApplicationsList" type="button">
            <span>Trademark</span>
            {!isMobile&& 
            <span> Applications</span>
            }
          </button>
        </div>
        <div className='content tab-content' id="v-tabContent">
          <div className="tab-pane fade show active" id="patentApplicationsList" role="tabpanel" aria-labelledby="patentApplicationsTab">
            <PatentApplicationsList 
            user={user} 
            patentApplicationPreferences={patentApplicationPreferences}
            patentApplications={patentApplications} 
            updatePatentApplications={updatePatentApplications} 
            sortHeader={patentSortHeader} 
            setSortHeader={setPatentSortHeader}
            sortOrder={patentSortOrder}
            setSortOrder={setPatentSortOrder}
            toggleNotifications={toggleNotifications}
            isMobile={isMobile} />
          </div>
          <div className="tab-pane fade" id="trademarkApplicationsList" role="tabpanel" aria-labelledby="trademarkApplicationsTab">
            <TrademarkApplicationsList 
            user={user} 
            trademarkApplicationPreferences={trademarkApplicationPreferences}
            trademarkApplications={trademarkApplications}
            updateTrademarkApplications={updateTrademarkApplications} 
            sortHeader={trademarkSortHeader}
            setSortHeader={setTrademarkSortHeader}
            sortOrder={trademarkSortOrder}
            setSortOrder={setTrademarkSortOrder}
            toggleNotifications={toggleNotifications}
            isMobile={isMobile} />
          </div>
        </div>
      </div>
      }
    </div>
  )
}
